import * as React from "react";

export interface ItemImageProps {
  image?: Partial<React.ImgHTMLAttributes<HTMLImageElement>>;
  className: string;
}

const ItemImage = (props: ItemImageProps) => {
  const { image, className } = props;

  if (!image) {
    return null;
  }

  return (
    <img className={className} {...image} alt="" tabIndex={-1} aria-hidden />
  );
};

ItemImage.displayName = "ItemImage";

export default ItemImage;
